import React, { useEffect } from "react";
import HowItWorks from "../customized/HowItWorks";
import SignUpForm from "./SignUpForm";
import { trackPageView, getSessionId, getUserId } from "../utils/pageTracking";

const CurbsideSignUpForm: React.FC = () => {
  useEffect(() => {
    // Track page view
    trackPageView('CurbsideSignUp', getSessionId(), getUserId());
  }, []);

  return (
    <div className="max-w-4xl mx-auto mt-16 py-12 px-4 bg-[#c3d3ab]">
      {/* How It Works Section */}
      <HowItWorks
        steps={[
          {
            title: "Sign Up",
            description: "Fill out the form below to join our curbside pickup program",
          },
          {
            title: "Collect",
            description: "Gather your compostable materials in the provided bucket",
          },
          {
            title: "Pick Up",
            description: "Place your bucket out on pickup day and we’ll swap it for a clean one!",
          },
        ]}
      />

      <div className="flex justify-center mt-5">
        <SignUpForm
          heading="Curbside Pick Up Service Sign Up"
          subheading=""
          showAdditionalFields={true}
          buttonText="Curbside Pickup: $25"
        />
      </div>
    </div>
  );
};

export default CurbsideSignUpForm;